"use strict";

var _interopRequireDefault = require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.OrderType = void 0;
require("core-js/modules/es.array.concat.js");
var _classCallCheck2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/classCallCheck.js"));
var _createClass2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/createClass.js"));
var _assertThisInitialized2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/assertThisInitialized.js"));
var _inherits2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/inherits.js"));
var _createSuper2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/createSuper.js"));
var _defineProperty2 = _interopRequireDefault(require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/@babel/runtime/helpers/defineProperty.js"));
var _tslib = require("tslib");
var _moment = _interopRequireDefault(require("moment"));
var _vuePropertyDecorator = require("vue-property-decorator");
var _CategoryChart = _interopRequireDefault(require("./components/chart/CategoryChart.vue"));
var _OrderTypeChart = _interopRequireDefault(require("./components/chart/OrderTypeChart.vue"));
var _ProfitChart = _interopRequireDefault(require("./components/chart/ProfitChart.vue"));
var _PanelGroup = _interopRequireDefault(require("./components/PanelGroup.vue"));
var _OrderTypeTrans;
var OrderType;
exports.OrderType = OrderType;
(function (OrderType) {
  OrderType["All"] = "ALL";
  OrderType["New"] = "NEW";
  OrderType["Old"] = "OLD";
})(OrderType || (exports.OrderType = OrderType = {}));
var OrderTypeTrans = (_OrderTypeTrans = {}, (0, _defineProperty2.default)(_OrderTypeTrans, OrderType.All, "Tất cả đơn"), (0, _defineProperty2.default)(_OrderTypeTrans, OrderType.New, "Đơn mới"), (0, _defineProperty2.default)(_OrderTypeTrans, OrderType.Old, "Đơn cũ"), _OrderTypeTrans);
var DashboardAdmin = /*#__PURE__*/function (_Vue) {
  (0, _inherits2.default)(DashboardAdmin, _Vue);
  var _super = (0, _createSuper2.default)(DashboardAdmin);
  function DashboardAdmin() {
    var _this;
    (0, _classCallCheck2.default)(this, DashboardAdmin);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "date", [(0, _moment.default)().format("YYYY-MM-DD"), (0, _moment.default)().format("YYYY-MM-DD")]);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "OrderType", OrderType);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "OrderTypeTrans", OrderTypeTrans);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "orderType", OrderType.All);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "pickerOptions", {
      shortcuts: [{
        text: "Hôm nay",
        onClick: function onClick(picker) {
          var end = new Date();
          var start = new Date();
          picker.$emit("pick", [start, end]);
        }
      }, {
        text: "Hôm qua",
        onClick: function onClick(picker) {
          var start = (0, _moment.default)().subtract(1, "day").toDate();
          var end = start;
          picker.$emit("pick", [start, end]);
        }
      }, {
        text: "Tuần này",
        onClick: function onClick(picker) {
          var start = (0, _moment.default)().startOf("week").toDate();
          var end = (0, _moment.default)().endOf("week").toDate();
          picker.$emit("pick", [start, end]);
        }
      }, {
        text: "Tuần trước",
        onClick: function onClick(picker) {
          var start = (0, _moment.default)().subtract(1, "week").startOf("week").toDate();
          var end = (0, _moment.default)().subtract(1, "week").endOf("week").toDate();
          picker.$emit("pick", [start, end]);
        }
      }, {
        text: "7 ngày qua",
        onClick: function onClick(picker) {
          var start = (0, _moment.default)().subtract(7, "days").toDate();
          var end = (0, _moment.default)().toDate();
          picker.$emit("pick", [start, end]);
        }
      }, {
        text: "Tháng này",
        onClick: function onClick(picker) {
          var start = (0, _moment.default)().startOf("month").toDate();
          var end = (0, _moment.default)().toDate();
          picker.$emit("pick", [start, end]);
        }
      }, {
        text: "Tháng trước",
        onClick: function onClick(picker) {
          var start = (0, _moment.default)().subtract(1, "month").startOf("month").toDate();
          var end = (0, _moment.default)().subtract(1, "month").endOf("month").toDate();
          picker.$emit("pick", [start, end]);
        }
      }, {
        text: "Tất cả",
        onClick: function onClick(picker) {
          picker.$emit("pick", ["", ""]);
        }
      }]
    });
    return _this;
  }
  (0, _createClass2.default)(DashboardAdmin, [{
    key: "convertedDate",
    get: function get() {
      return {
        from: this.date[0],
        to: this.date[1]
      };
    }
  }]);
  return DashboardAdmin;
}(_vuePropertyDecorator.Vue);
DashboardAdmin = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  components: {
    ProfitChart: _ProfitChart.default,
    PanelGroup: _PanelGroup.default,
    CategoryChart: _CategoryChart.default,
    OrderTypeChart: _OrderTypeChart.default
  }
})], DashboardAdmin);
var _default = DashboardAdmin;
exports.default = _default;